import * as d3 from 'd3';

export const addYPercentageValue = (arr) => {
  const sumMap = {};

  arr.forEach((item) => {
    const { xGroupId, yValue } = item;
    sumMap[xGroupId] = (sumMap[xGroupId] || 0) + yValue;
  });

  return arr.map((item) => {
    const maxGroupVal = sumMap[item.xGroupId];

    return {
      ...item,
      yPercentageValue:
        maxGroupVal > 0 ? (100 / sumMap[item.xGroupId]) * item.yValue : 0,
    };
  });
};

export const formatChartData = (data, percentage) => {
  const nestedData = d3
    .nest()
    .key((d) => d.xGroupId)
    .key((d) => d.xDatasetId)
    .entries(data);

  return nestedData;
};
